module.exports = __webpack_public_path__ + "img/06.4dbf4e02.jpg";